/**
 * CR431: Normalize deal records to guarantee `id` field exists.
 * Resolves id from deal_id, canonical_deal_json.id fallbacks.
 */

import type { DealSurface } from "./dealViewRegistry";

export function normalizeDealRecord<T extends Record<string, any>>(
  deal: T,
  surface: DealSurface
): T & { id: string } {
  const id =
    deal?.id ??
    deal?.deal_id ??
    deal?.canonical_deal_json?.id ??
    null;

  if (!id) {
    if (import.meta.env.DEV) {
      console.error("[SSOT] Deal missing id", { surface, deal });
    }
    return { ...(deal as any), id: "missing-id" };
  }

  return { ...(deal as any), id };
}
